import { createServerFn } from "@tanstack/react-start";

import { enrollmentSchemaForLocale, type EnrollmentLocale } from "./enrollment-schema";


export const submitEnrollment = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => {
    const candidate = data as { locale?: unknown };
    const locale: EnrollmentLocale = candidate?.locale === "en" || candidate?.locale === "es" ? candidate.locale : "sv";
    return enrollmentSchemaForLocale(locale).parse(data);
  })
  .handler(async ({ data }) => {
    if (data.website) {
      return { ok: true as const, ids: [] as string[] };
    }

    const { performEnrollmentSubmit } = await import("./enrollment-submit.server");
    const result = await performEnrollmentSubmit(data);
    return { ok: true as const, ids: result.ids, groupId: result.groupId };
  });
